<template style="height: 100%;">
  <div class="ExmCon">
    <el-dialog :title="$t('original.languages179')" :visible.sync="dialogTableVisible" width="38%">
      <table style="border-radius: 18px; width: 100%;padding: 10px 0px;">
        <tr style="height: 30px;">
          <td class="td_left">{{ $t('original.languages185') }}：</td>
          <td class="td_right">{{ Information.CounselorName }}</td>
        </tr>
        <tr style="height: 30px;">
          <td class="td_left">{{ $t('original.languages218') }}：</td>
          <td class="td_right">{{ Information.VisitorID }}</td>
        </tr>
        <tr style="height: 30px;">
          <td class="td_left">{{ $t('original.languages219') }}：</td>
          <td class="td_right">
            <el-input v-model="Information.RelieveRecordNum" placeholder="请输入内容"></el-input>
          </td>
        </tr>
        <tr style="height: 30px;">
          <td class="td_left">已解禁次数 ：</td>
          <td class="td_right">{{ Information.Unban }}</td>
        </tr>
        <tr style="height: 30px;">
          <td class="td_left">{{ $t('original.languages147') }} ：</td>
          <td class="td_right">{{ Information.Assessment }}</td>
        </tr>
        <tr style="height: 30px;">
          <td class="td_left">{{ $t('original.languages220') }}：</td>
          <td class="td_right">{{ Information.RelieveRecordCause == "" ? $t('original.languages221') : Information.RelieveRecordCause}}
          </td>
        </tr>
      </table>
      <table style="margin-top:0px; width:100%">
        <tr>
          <td class="td_left">{{ $t('original.languages214') }}</td>
          <td class="td_right" :style="Information.RelieveRecordState == 0 ? 'color: rgba(0, 136, 255, 1);' : Information.RelieveRecordState == -1 ? 'color: rgba(242, 75, 78, 1);' : Information.RelieveRecordState == 1  ? 'color: rgba(21, 191, 109, 1); ' : 'color: rgba(141, 141, 141, 1);'">
            {{Information.RelieveRecordState == 1 ? "待审批" : Information.RelieveRecordState == 3 ? "已拒绝" : Information.RelieveRecordState == 2 ? "已同意" : "已撤销"}}
          </td>
        </tr>
        <tr v-if="Information.RelieveRecordState == 3 && Information.Isshow">
          <td class="td_left"> {{ $t('original.languages215') }}</td>
          <td class="td_right">{{ Information.RelieveRecordNotes }}</td>
        </tr>
        <tr v-if="(Information.RelieveRecordState == 2 || Information.RelieveRecordState == 3) && Information.Isshow">
          <td class="td_left">{{ $t('original.languages192') }}</td>
          <td class="td_right">{{ Information.approverName }}</td>
        </tr>
        <tr v-if="(Information.RelieveRecordState == 2 || Information.RelieveRecordState == 3) && Information.Isshow">
          <td class="td_left">{{ $t('original.languages193') }}</td>
          <td class="td_right">{{ Information.ApproverTime }}</td>
        </tr>
        <tr v-if="Information.RelieveRecordState == 1">
          <td style="padding-top: 20px;" class="td_left">{{ $t('original.languages194') }}</td>
          <td style="padding-top: 20px;" class="td_right">
            <el-input :placeholder="$t('original.languages194')" type="textarea" v-model="Information.RelieveRecordNotes"></el-input>
          </td>
        </tr>
      </table>
      <div class="buttons" style="width: 100%;margin-top: 20px;" v-if="Information.RelieveRecordState == 1">
        <el-button type="primary" :loading="UpdateRelieveRecordload" @click="UpdateRelieveRecordState((Information.RelieveRecordState = 3),Information.RelieveRecordID)">{{ $t('original.languages195') }}</el-button>
        <el-button type="primary" :loading="UpdateRelieveRecordload" @click="UpdateRelieveRecordState((Information.RelieveRecordState = 2),Information.RelieveRecordID)">{{ $t('original.languages196') }}</el-button>
      </div>
    </el-dialog>

    <el-tabs type="border-card" class="list-cnt">
      <el-tab-pane :label="$t('original.languages197')">
        <span slot="label">{{ $t('original.languages197') }}</span>

        <el-button :disabled='spcinu' type="primary" @click="batchfun('1','1')">选中同意</el-button>
        <el-button :disabled='spcinu' type="primary" @click="batchfun('-1','1')">选中拒绝</el-button>
        <el-button :disabled='spcinu' type="success" @click="batchfun('1','2')">全部同意</el-button>
        <el-button :disabled='spcinu' type="danger" @click="batchfun('-1','2')">全部拒绝</el-button>

        <el-table :data="UndoTableData" style="margin-top:15px" v-loading="IsDataLoad" :element-loading-text="$t('original.languages22')" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>

          <el-table-column :label="$t('original.The_serial_number')" width="100px" >

            
            <template slot-scope="scope">
              {{ (pageIndex - 1) * 10 + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="VisitorName" :label="$t('original.languages218')"></el-table-column>
          <el-table-column prop="RelieveRecordNum" :label="$t('original.languages219')"></el-table-column>
          <el-table-column prop="Used" :label="$t('original.languages222')"></el-table-column>
          <el-table-column prop="RelieveRecordCause" :label="$t('original.languages220')"></el-table-column>
          <el-table-column prop="CounselorName" :label="$t('original.languages185')"></el-table-column>
          <el-table-column prop="CreatorTime" :label="$t('original.languages223')"></el-table-column>
          <el-table-column :label="$t('original.languages190')" width="100">
            <template>
              <span class="state-blue" style="color: #fff;background-color: rgba(0, 136, 255, 1);padding: 8px;border-radius: 12px;"> {{ $t('original.languages200') }} </span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('original.languages49')" width="100" align="center">
            <template slot-scope="scope">
              <span class="option-blue" style="cursor: pointer;color: rgba(0, 136, 255, 1) !important;" @click="handleCheck(scope.row);Information.Isshow = false;">{{ $t('original.languages201') }}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="margin-top: 20px; text-align: right" @current-change="handleCurrentChange" :current-page.sync="pageIndex" :page-size="pageSize" layout="total, prev, pager, next" :total="UndoCount" v-if="UndoCount > 0"></el-pagination>
      </el-tab-pane>
      <el-tab-pane :label="$t('original.languages202')">
        <el-table :data="DoTableData" v-loading="IsDataLoad" :element-loading-text="$t('original.languages22')">
          <el-table-column :label="$t('original.The_serial_number')" width="100px">
            <template slot-scope="scope">
              {{ (pageIndex - 1) * 10 + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="VisitorName" :label="$t('original.languages218')"></el-table-column>
          <el-table-column prop="RelieveRecordNum" :label="$t('original.languages219')"></el-table-column>
          <el-table-column prop="Used" :label="$t('original.languages222')"></el-table-column>
          <el-table-column prop="RelieveRecordCause" :label="$t('original.languages220')"></el-table-column>
          <el-table-column prop="CounselorName" :label="$t('original.languages185')"></el-table-column>
          <el-table-column prop="CreatorTime" :label="$t('original.languages217')"></el-table-column>
          <el-table-column :label="$t('original.languages214')" width="100">
            <template slot-scope="scope">
              <span class="state-green" v-if="scope.row.RelieveRecordState == 2" style="color: #fff;background-color: rgba(21, 191, 109, 1);padding: 8px;border-radius: 12px;">已同意</span>
              <span class="state-red"   v-else-if="scope.row.RelieveRecordState == 3" style="color: #fff;background-color: rgba(242, 75, 78, 1);padding: 8px;border-radius: 12px;">已拒绝</span>
              <span class="state-gray"  v-else>已撤销</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('original.languages49')" width="100">
            <template slot-scope="scope">
              <span class="option-blue" style="cursor: pointer;color: rgba(0, 136, 255, 1) !important;" @click="handleCheck(scope.row);Information.Isshow = true;">{{ $t('original.languages174') }}</span>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination style="margin-top:20px;text-align: right" @current-change="handleCurrentChange" :current-page.sync="pageIndex" :page-size="pageSize" layout="total, prev, pager, next" :total="DoCount" v-if="DoCount > 0"></el-pagination>

      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  data() {
    return {
      spcinu:false,
      IsDataLoad: true,
      dialogTableVisible: false, //打开详情框
      pageSize: 10,
      pageIndex: 1,
      UndoTableData: [],
      DoTableData: [],
      UndoCount: -1,
      DoCount: -1,
      appointmentList: [],
      Information: {
        Unban: "",
        RelieveRecordID: "",
        VisitorID: "",
        RelieveRecordNum: "",
        Used: "",
        RelieveRecordCause: "",
        CreatorTime: "",
        RelieveRecordState: "",
        Assessment: "",
        CounselorID: "",
        RelieveRecordNotes: "",
        approverName: "",
        ApproverTime: "",
        Isshow: false,
        VisitorName: "",
        CounselorName: "",
      },
      UpdateRelieveRecordload:false,
      DeleteKeys:[]
    };
  },
  created() {
    this.GetData();
  },
  methods: {
    batchfun(val,type){
      if(type == 1){
        this.spcinu = true;
        if(this.DeleteKeys.length > 0){
          this.$Http_Post('management/consultsubscribe/batchhandleban', {handleFlag: val,ids:this.DeleteKeys}).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.spcinu = false;
              this.Global.request_successful(res.Message);
              window.location.reload();
            } else {
              this.spcinu = false;
              this.$message.error(res.Message);
            }
          })
        }else{
          alert('请选择选项！');
        }
      }else if(type == 2){//全部
        this.spcinu = true;
        this.$Http_Post('management/consultsubscribe/batchhandleban', {handleFlag: val}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.spcinu = false;
            this.Global.request_successful(res.Message);
            window.location.reload();
          } else {
            this.spcinu = false;
            this.$message.error(res.Message);
          }
        })
      }
    }, 

    // 全选
    handleSelectionChange(e){
      this.DeleteKeys = [];
      for(let item of e){
        this.DeleteKeys.push(item.RelieveRecordID);
      }
    },


    GetData() {
      this.IsDataLoad = true;
      let _this = this;
      this.$Http_Post("ConsultSubscribe/GetAllExamineBan", {pageSize: this.pageSize,pageIndex: this.pageIndex}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          _this.UndoTableData = res.Data.UndoTableData;
          _this.DoTableData = res.Data.DoTableData;
          _this.UndoCount = res.Data.UndoCount;
          _this.DoCount = res.Data.DoCount;
          _this.IsDataLoad = false;
          // _this.$parent.RefreshBanCount(_this.UndoCount);
        }
      });
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetData();
    },
    handleCheck(obj) {
      let _this = this;
      _this.dialogTableVisible = true;
      _this.UpdateRelieveRecordload=false;
      _this.Information.RelieveRecordID = obj.RelieveRecordID;
      _this.Information.VisitorID = obj.VisitorID;
      _this.Information.RelieveRecordNum = obj.RelieveRecordNum;
      _this.Information.Used = obj.Used;
      _this.Information.RelieveRecordCause = obj.RelieveRecordCause;
      _this.Information.CreatorTime = obj.CreatorTime;
      _this.Information.UserName = obj.UserName;
      _this.Information.RelieveRecordState = obj.RelieveRecordState;
      _this.Information.Assessment = obj.Assessment;
      _this.Information.CounselorID = obj.CounselorID;
      _this.Information.VisitorName = obj.VisitorName;
      _this.Information.CounselorName = obj.CounselorName;
      _this.Information.RelieveRecordNotes = obj.RelieveRecordNotes;
      _this.Information.approverName = obj.approverName;
      _this.Information.ApproverTime = obj.ApproverTime;
      _this.Information.Unban = obj.Unban;
    },

    selectappointment(starTime, endTime, UserAccount) {
      this.$Http_Post("ConsultSubscribe/GetLeaveAppointment", {starTime: starTime,endTime: endTime,UserID: UserAccount}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.appointmentList = res.Data;
        } else {
          this.$notify.closeAll();
          this.$notify.error({
            title: this.$t('original.languages168'),
            message: res.data.Message,
          });
        }
      });
    },

    UpdateRelieveRecordState(RelieveRecordState, RelieveRecordID) {
      let RelieveRecordNotes = "";
      if (RelieveRecordState == 3) {
        RelieveRecordNotes = this.Information.RelieveRecordNotes;
      }
      this.UpdateRelieveRecordload=true;
      this.$Http_Post("ConsultSubscribe/UpdateApplyRelieve", {RelieveRecordID: RelieveRecordID,RelieveRecordNotes: RelieveRecordNotes,RelieveRecordState: RelieveRecordState,RelieveRecordNum: this.Information.RelieveRecordNum}).then((res) => {
        this.UpdateRelieveRecordload=false;
        if (res.Code == 200 || res.Code == 0) {
          if (RelieveRecordState == 3) {
            this.$message({
              message: this.$t('original.languages204'),
              type: "success",
            });
          } else {
            this.$message({
              message: this.$t('original.languages203'),
              type: "success",
            });
          }
          this.GetData();
          this.dialogTableVisible = false;
          // this.$parent.RefreshBanCount(-1);
        } else {
          this.$message.error(this.$t('original.languages206'));
        }
        
      });
    },
  },
};
</script>
<style>
.el-tabs {
  height: 100%;
}
.list-cnt {
  height: 100%;
}
.td_left{width: 90px;}
.ExmCon .el-input__inner{width: 40%;}
.el-table--enable-row-transition .el-table__body td{text-align: center;}
</style>
